var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 47,
    viewBox: "0 0 45 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.696 34C15.3973 34 15.184 33.8933 15.056 33.68C14.9493 33.4453 14.9173 33.0933 14.96 32.624L15.024 32.144C15.1307 31.2267 15.4613 30.768 16.016 30.768H20.72L22.32 15.376L17.648 16.112C17.2853 16.176 17.0507 16.016 16.944 15.632C16.8373 15.248 16.784 14.8533 16.784 14.448C16.784 14.0427 16.8267 13.7227 16.912 13.488C16.9973 13.2533 17.2427 13.0933 17.648 13.008L25.552 11.504C25.8293 11.504 26.096 11.5893 26.352 11.76C26.608 11.9307 26.7253 12.1227 26.704 12.336L24.752 30.768H28.592C28.912 30.768 29.1253 30.8853 29.232 31.12C29.36 31.3333 29.4027 31.664 29.36 32.112L29.296 32.624C29.1893 33.5413 28.848 34 28.272 34H15.696Z",
    fill: "#181533"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 23.5C43.5 35.7124 34.0372 45.5 22.5 45.5C10.9628 45.5 1.5 35.7124 1.5 23.5C1.5 11.2876 10.9628 1.5 22.5 1.5C34.0372 1.5 43.5 11.2876 43.5 23.5Z",
    stroke: "#181533",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOne);
export default __webpack_public_path__ + "static/media/stepOne.7a7a02e4a4184c70dfd307b973045c45.svg";
export { ForwardRef as ReactComponent };